import Slider from '../classes/slider.js';

export default class Countdown {
    
    static get selector() {
        return '.countdown';
    }

    constructor(el) {
        this.el = el;
        this.section = document.querySelector('.wwaIntro');
        let slides = this.getSlides();
        if(slides.length > 1) {
            this.slider = new Slider(this.getSliderConfig(), slides);
            window.onblur = function() {window.blurred = true;};
            window.onfocus = function() {window.blurred = false;};
            setTimeout(() => {
                setInterval(() =>{
                    if(window.blurred) return;
                    this.slider.next();
                }, 600);
            }, 400);
        }

        setTimeout(() => {
            this.el.classList.add('countdown--active');
            this.section.classList.add('wwaIntro--active');
        }, 100);





        
    }

    getSlides() {
        let slides = [];
        this.el.querySelectorAll('.countdown__item').forEach((element, index) => {
            slides.push(element);
        });
        return slides;
    }

    getSliderConfig() {
        return {
            currentClass: 'countdown__item--active',
            preparePreviousClass: 'countdown__item--prepPrev',
            previousClass: 'countdown__item--prev',
            nextClass: 'countdown__item--next',
            prepareNextClass: 'countdown__item--prepNext',

            loopSlides: true,
            animationDuration: 400,
        };
    }

 
    setEvents() {

    }

}
